import React, { FC, useContext } from 'react';

import {
  CircleCloseIcon,
  ClockIcon,
  SuccessIcon,
  Tooltip,
} from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { EBeneficiaryStatus } from '../../Modals/components/TinkoffModal/interfaces';
import s from '../IntegrationCard.module.scss';
import { IStatusProps } from '../interfaces';

export const Status: FC<IStatusProps> = ({
  featuresFlag,
  status,
  setting,
  isAvailable,
}) => {
  const { t } = useContext(LocalizationContext);

  const {
    state: { settings },
  } = useContext(SettingsContext);

  return (
    <>
      {featuresFlag === 'telegram_notify'
        ? isAvailable &&
          settings.telegramChannelId?.id && (
            <div className={s.success}>
              <Tooltip
                contentClassName={s.success_tooltip}
                header={t('online')}
                content={t('integration.online')}
              >
                <SuccessIcon
                  className={s.success_icon}
                  size="s"
                  color="green"
                />
              </Tooltip>
            </div>
          )
        : featuresFlag !== 'sbp_tinkoff'
        ? isAvailable &&
          setting &&
          Boolean(settings[setting]) === true && (
            <div className={s.success}>
              <Tooltip
                contentClassName={s.success_tooltip}
                header={t('online')}
                content={t('integration.online')}
              >
                <SuccessIcon
                  className={s.success_icon}
                  size="s"
                  color="green"
                />
              </Tooltip>
            </div>
          )
        : setting &&
          Boolean(settings[setting]) === true && (
            <>
              {isAvailable && status && status === EBeneficiaryStatus.APPROVED && (
                <div className={s.success}>
                  <Tooltip
                    contentClassName={s.success_tooltip}
                    header={t('online')}
                    content={t('integration.online')}
                  >
                    <SuccessIcon
                      className={s.success_icon}
                      size="s"
                      color="green"
                    />
                  </Tooltip>
                </div>
              )}

              {isAvailable && status && status === EBeneficiaryStatus.PENDING && (
                <div className={cn(s.success, s.pending)}>
                  <Tooltip
                    contentClassName={s.success_tooltip}
                    header={t('checked')}
                    content={t('pending')}
                  >
                    <ClockIcon
                      className={s.success_icon}
                      size="s"
                      color="warning"
                    />
                  </Tooltip>
                </div>
              )}

              {isAvailable && status && status === EBeneficiaryStatus.ERROR && (
                <div className={cn(s.success, s.error)}>
                  <Tooltip
                    contentClassName={cn(s.success_tooltip, s.error_tooltip)}
                    header={t('rejected')}
                    content={t('rejected.text')}
                  >
                    <CircleCloseIcon
                      className={s.success_icon}
                      size="s"
                      color="error"
                    />
                  </Tooltip>
                </div>
              )}
            </>
          )}
    </>
  );
};
